<template>
  <div class="item-user-userinfo">
    <a-dropdown placement="bottomRight">
      <div class="header-user">
        <i><img src="~@/assets/images/avatar_default.png"/></i>
        <span class="header-name">欢迎您：{{ userInfo.realName }}</span>
      </div>
      <a-menu slot="overlay" style="width: 150px">
        <a-menu-item @click="goChangePassword">
          <a-icon type="setting" />
          修改密码</a-menu-item
        >
        <a-menu-divider />
        <a-menu-item @click="logout">
          <a-icon type="poweroff" />
          退出登录</a-menu-item
        >
      </a-menu>
    </a-dropdown>
    <AdminChangePassword ref="adminChangePasswordModal" />
  </div>
</template>

<script>
import storage from "@/utils/storage";
import { Login } from "@/api";
import AdminChangePassword from "@/components/Public/AdminChangePassword";
import { mapState } from "vuex";
export default {
  components: { AdminChangePassword },
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["userInfo"]),
  },
  mounted() {},
  methods: {
    // 修改密码
    goChangePassword() {
      this.$refs.adminChangePasswordModal.open(this.userInfo);
    },

    logout() {
      Login.check_logout().then(res => {
        if (res.code == 200) {
          storage.clear();
          this.$store.commit("setting/setMenu", []); // 全部路由存入
          this.$store.commit("setting/setIsMenu", false); // 是否加载过路由
          this.$router.replace({ path: "/login" });
        }
      });
      // location.reload();
    },
  },
};
</script>
<style lang="less" scoped>
.item-user-userinfo {
  height: 100%;
  position: relative;
}
.header-user {
  display: flex;
  transition: all 0.3s;
  padding: 5px 15px 5px 15px;
  height: 100%;
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.03);
  }
  i {
    display: block;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    overflow: hidden;
    width: 30px;
    height: 30px;
    line-height: 0;
  }
  span {
    display: block;
  }
  .header-pic {
    border-radius: 3px;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }
  .header-name {
    padding: 0 0 0 5px;
    color: #dbdbdb;
    line-height: 30px;
  }
}
</style>
